import { getRootUrl } from '@share-a-cart/shared-utils';
import dayjs from 'dayjs';
import { OrgAnalyticsExcelData } from 'src/types';
import { utils, writeFile } from 'xlsx';

export const exportOrgAnalyticsToExcel = (
  analyticsData: OrgAnalyticsExcelData | null,
  startDate?: string,
  endDate?: string,
  requesters?: string[] | 'All',
  vendors?: string[] | 'All',
) => {
  if (!analyticsData) {
    return;
  }

  const startDateString = startDate
    ? dayjs(startDate).format('MM/DD/YYYY')
    : 'All';
  const endDateString = endDate ? dayjs(endDate).format('MM/DD/YYYY') : 'All';
  const requestersString =
    requesters === 'All' ? 'All' : (requesters?.length ?? '');
  const vendorsString =
    vendors === 'All' ? 'All' : (vendors?.join(', ') ?? 'All');

  const rows: {
    Vendor: string;
    ID: string;
    'Date Requested': string;
    'Requested By': string;
    'Approved?': string;
    '# of Items': number;
    'Total Cost': string;
  }[] = [];

  analyticsData.analytics.forEach((analytic) => {
    rows.push({
      Vendor: analytic.cart.vendorDisplayName || analytic.cart.vendor,
      ID: analytic.cart.id,
      'Date Requested': dayjs(analytic.requestedAt).format('MM/DD/YYYY'),
      'Requested By': `${analytic.requestedBy.email}\n${analytic.requestedBy.name || ''}`,
      'Approved?': analytic.status === 'approved' ? 'Yes' : 'No',
      '# of Items': analytic.cart.cartTotalQty || 0,
      'Total Cost': analytic.formattedCartPrice || '0',
    });
  });

  const rowOrigin = 6;

  // @ts-expect-error - The xlsx library supports string origins (e.g., "A6") at runtime, but its type definitions may not reflect this.
  // This usage is safe and tested, so we suppress the TypeScript error here.
  const ws = utils.json_to_sheet(rows, { origin: `A${rowOrigin}` });
  const wb = utils.book_new();

  // add hyperlinks to Cart ID column
  for (let i = rowOrigin + 1, j = 0; j < rows.length; i++, j++) {
    ws[`B${i}`].l = {
      Target: `${getRootUrl()}/get/${ws[`B${i}`].v}`,
    };
  }

  utils.book_append_sheet(wb, ws, 'Analytics');

  utils.sheet_add_aoa(ws, [[`Start Date: ${startDateString}`]], {
    origin: 'A1',
  });
  utils.sheet_add_aoa(ws, [[`End Date: ${endDateString}`]], { origin: 'A2' });
  utils.sheet_add_aoa(ws, [[`Requesters: ${requestersString}`]], {
    origin: 'A3',
  });
  utils.sheet_add_aoa(ws, [[`Vendors: ${vendorsString}`]], { origin: 'A4' });

  const finalRowOrigin = rowOrigin + rows.length + 1;
  const finalRowData = [
    `Total Carts: ${analyticsData.totalCarts}`,
    '',
    '',
    '',
    '',
    `Total Items: ${analyticsData.totalItems}`,
    `Total Price: ${analyticsData.totalPrice}`,
  ];

  utils.sheet_add_aoa(ws, [finalRowData], { origin: `A${finalRowOrigin}` });

  // Column Widths
  const wscols = [
    {
      // Vendor
      wch: 16,
    },
    {
      // ID
      wch: 8,
    },
    {
      // Date Requested
      wch: 20,
    },
    {
      // Requested By
      wch: 30,
    },
    {
      // Status
      wch: 10,
    },
    {
      // # of Items
      wch: 20,
    },
    {
      // Total Cost
      wch: 20,
    },
  ];
  ws['!cols'] = wscols;

  writeFile(wb, 'Analytics.xlsx');
};
